import { render, staticRenderFns } from "./SpottyLogin.vue?vue&type=template&id=0d22728e&scoped=true&"
import script from "./SpottyLogin.vue?vue&type=script&lang=ts&"
export * from "./SpottyLogin.vue?vue&type=script&lang=ts&"
import style1 from "./SpottyLogin.vue?vue&type=style&index=1&id=0d22728e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d22728e",
  null
  
)

export default component.exports